import { bpeConfig } from '@enterprise/common';
import {
  createLdProvider,
  type LdProviderProps,
  useUserIdentification
} from 'integrations/launchDarkly/impl/createLDProvider';
import { LaunchDarklyGlobalFlagsContext } from 'integrations/launchDarkly/providers/LaunchDarklyGlobalFlagsContext';
import React, { FC } from 'react';

const enableGlobalDarkly = !!bpeConfig.integrations.launchDarklyGlobalClientId;

const LD = createLdProvider({
  displayName: 'DarklyGlobalProvider',
  clientSideID: bpeConfig.integrations.launchDarklyGlobalClientId,
  enabled: enableGlobalDarkly,
  reactContext: LaunchDarklyGlobalFlagsContext
});

export const GlobalDarklyProvider: FC<LdProviderProps & Required<React.PropsWithChildren>> = ({
  children,
  ...identity
}) => {
  useUserIdentification(LD, identity);

  return <LD.Provider>{children}</LD.Provider>;
};
